import type { FC } from 'react';
import { useTouch } from '@/hooks/useTouch';
import { IconButton } from '@/components/Button/IconButton';
import { X } from 'react-feather';
import classes from './DrawerActions.module.css';

interface Props {
  hasPreview: boolean;
  closeDrawer: () => void;
}

export const DrawerActions: FC<Props> = ({ hasPreview, closeDrawer }) => {
  const isTouch = useTouch();

  // Show drag handle on mobile for touch devices or when preview is enabled
  // (the corner chevron in the header handles expand/collapse instead).
  return isTouch || hasPreview ? (
    <div className={classes.popupArea} data-testid="drawer-actions-handle">
      <span className={classes.popupIndicator} />
    </div>
  ) : (
    <div className={classes.closeDrawer} data-testid="drawer-actions-close">
      <IconButton
        Component={X}
        color="var(--os-mainColor-foreground-primary)"
        iconSize={24}
        onClick={closeDrawer}
      />
    </div>
  );
};
